import React from "react";

const Output = ({ factText }) => {
    return (
        <div className="m3 mw6 pa3 br3 output">
            {factText}
        </div>
    );
}

export default Output;